export const slug = (link) => {
  if (link) {
    if (link.startsWith("/")) return link;
    else return `/${link}`;
  }
};
